module.exports = __webpack_public_path__ + "static/media/company.accaa787.png";